/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup, Card, CardHeader, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts,setCompanies,setSelectedContactUser} from '../../actions/quote'
import { toast } from 'react-toastify';

import {
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";


function Index(props) {
  const [contacts, setContacts] = useState([]);
  const [contact, setContact] = useState(null);
  const [editMode, setEditMode] = useState(false);

  
  
  const main = useRef();

  useEffect(() => {    
    if(props.quote.contact_updated || props.quote.company_updated){
      setEditMode(false);
      if(contact && !contact['id'])
        setContact(null)
    }
  },[props.quote.contact_updated, props.quote.company_updated]);
 
  useEffect(() => {
    // var userid = getuserid();
    // var role = getuserrole();
    if(props.company){
      if(props.company.contacts){
        var newContacts = props.company.contacts
        setContacts(newContacts)
        if(contact && contact['id']){
          var flag = false
          for(var i = 0; i < newContacts.length; i++){ //check if selected contact exist
            if(newContacts[i].id == contact['id']){
              flag = true; break;
            }
          }
          if(!flag){
            setContact(null)
          }
        }
        // setContact(null)
      }
    }
    if(!props.company){
      setContact(null)
    }
  },[props.company]);

  const onChangeContact = (newContactId)=>{
    if(newContactId){
      var newContact = null;
      for(var i = 0; i < contacts.length; i++){
        if(contacts[i].id == newContactId){
          newContact = contacts[i];
          setContact(newContact);
          break;
        }
      }
    }
    else{
      setContact(null);
    }
  }

  const addTrigerContact = (e)=>{
    setContact(null)
    toggleEditMode();
  }
  const toggleEditMode = ()=>{
    setEditMode(!editMode);
  }
  console.log("contact", contact)

  return (
    <>
      <div className="bg-transparent border-0">
          <Row>
            <Col md="12">
              <div className="px-lg-3">
                <Form role="form">
                  <Row>
                    <Col md="8">
                      <FormGroup className="mb-1">
                        <Input type="select" value={contact?contact.id:''} name="id" onChange={(e)=>onChangeContact(e.target.value)}>
                          <option value="">None</option>
                          {
                            (() => {
                              var element = [];
                              for(var key in contacts){
                                element.push(
                                  <option key={key} value={contacts[key]['id']}>{(contacts[key]['firstname']?contacts[key]['firstname']:"")+" "+(contacts[key]['lastname']?contacts[key]['lastname']:"")+(contacts[key]['company_name']?(" - "+contacts[key]['company_name']):"")}</option>
                                )
                              }
                              return element
                            })()
                          }
                        </Input>
                          {/* <Input className="input-field" disabled = {!editMode} placeholder="Company Name" type="text" name="company" value={contact?contact.company:''} onChange={(e)=>setContact({...contact, company:e.target.value})}/> */}

                      </FormGroup>
                    </Col>
                    <Col md="4" className="d-flex align-items-center">
                        <div onClick={(e)=>addTrigerContact(e)} className="d-flex align-items-center cursor-pointer">
                          <i style={{fontSize:19, marginTop:1}} className="fa fa-plus-square-o cursor-pointer mr-1" aria-hidden="true"></i>
                          <span style={{fontSize:14}}>New </span>
                        </div>
                    </Col>
                  </Row>
                  <hr/>
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="Company Name" type="text" name="company_name"  value={contact?contact.company_name:''} onChange={(e)=>setContact({...contact, company_name:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="First Name" type="text" name="firstname"  value={contact?contact.firstname:''} onChange={(e)=>setContact({...contact, firstname:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="SurName" type="text" name="lastname"  value={contact?contact.lastname:''} onChange={(e)=>setContact({...contact, lastname:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="Position" type="text" name="position"  value={contact?contact.position:''} onChange={(e)=>setContact({...contact, position:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="Mobile" type="text" name="mobile"  value={contact?contact.mobile:''} onChange={(e)=>setContact({...contact, mobile:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="8">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="Email" type="email" name="email"  value={contact?contact.email:''} onChange={(e)=>setContact({...contact, email:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="Street" type="text" name="address"  value={contact?contact.address:''} onChange={(e)=>setContact({...contact, address:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="Suburb" type="text" name="suburb"  value={contact?contact.suburb:''} onChange={(e)=>setContact({...contact, suburb:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="State" type="text" name="state"  value={contact?contact.state:''} onChange={(e)=>setContact({...contact, state:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="Post Code" type="text" name="postcode"  value={contact?contact.postcode:''} onChange={(e)=>setContact({...contact, postcode:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="8">
                      <FormGroup className="mb-2">
                        <div className="custom-control custom-checkbox">
                          <input
                            className="custom-control-input"
                            id="customCheck1"
                            type="checkbox"
                            name="primary_set"
                            checked={contact?contact.primary_set:false}
                            value={1} onChange={(e)=>setContact({...contact, primary_set:!(contact?contact.primary_set:false)})}
                          />
                          <label className="custom-control-label" htmlFor="customCheck1">
                            <b>Primary Contact</b>
                          </label>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                  {props.mode!='view'&&
                  <Row className="mt-2">
                    <Col md="6">
                      <div onClick={(e)=>toggleEditMode()} className="d-flex align-items-center cursor-pointer">
                        <i style={{fontSize:18, marginTop:1}} className="fa fa-pencil cursor-pointer mr-1" aria-hidden="true"></i>
                        <span style={{fontSize:14}}>Edit</span>
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="text-right">
                        <i onClick={(e)=>{props.updateContact(contact) }}  style={{fontSize:18, marginTop:1}} className="fa fa-save cursor-pointer mr-1" aria-hidden="true"></i>
                      </div>
                    </Col>
                  </Row>
                  }
                </Form>
              </div>
            </Col>
          </Row>
      </div>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
    setCompanies: companies=>dispatch(setCompanies(companies)),
    setSelectedContactUser: data=>dispatch(setSelectedContactUser(data)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
